import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { usStatesAndTerritories } from './util';

import type { BusinessAddressFormData } from '@/components/TaxExemption/types';

type SelectStateProps = {
  control: Control<BusinessAddressFormData>;
};

export function SelectState({ control }: SelectStateProps) {
  return (
    <Controller
      control={control}
      name="region"
      render={({
        field: { value = null, onChange, ...field },
        formState: { errors },
      }) => (
        <Autocomplete
          autoHighlight
          autoSelect
          getOptionLabel={(option) => usStatesAndTerritories[option] ?? option}
          onChange={(_event, newValue) => onChange(newValue)}
          options={Object.keys(usStatesAndTerritories)}
          renderInput={(params) => (
            <TextField
              {...params}
              InputLabelProps={{ required: true, ...params.InputLabelProps }}
              error={!!errors.region}
              helperText={errors.region?.message}
              inputProps={{
                autoComplete: 'address-level1',
                ...params.inputProps,
              }}
              label="State"
              placeholder="State"
            />
          )}
          value={value as string}
          {...field}
        />
      )}
      rules={{ required: 'Please select a state.' }}
    />
  );
}
